import { Card } from "antd";
import React from "react";
import "./styles.css";

const EmployeementContractTemplate = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      <Card title="Employeement Contract" bordered className="container">
        <h2 className="t-center m-0">{props.arabicTitle}</h2>
        <h2 className="t-center m-0">{props.englishTitle}</h2>
        <table style={{ margin: "20px 10px", width: "100%" }}>
          <td style={{ width: "50%" }}>
            <h2>Contract ID : {props.idNo}</h2>

            <p>
              This contract was created electronically under the supervision of
              the Ministry of Human Resources and Social Development, Kingdom of
              Saudi Arabia on
              {props.issueDate}, between:
            </p>
            <p>
              <i>
                <b>
                  {" "}
                  <u>First Party</u>{" "}
                </b>
              </i>{" "}
              <br />
              <b>Company/Corporation: {props.companyName}</b> <br />
            </p>
          </td>
          <td dir="rtl" style={{ width: "50%" }}>
            <h2>رقم العقد:{props.idNo}</h2>
            <p>
              أُبرم هذا العقد الكترونياً تحت إشراف وزارة الموارد البشرية
              والتنمية الاجتماعية، المملكة العربية السعودية في يوم م بين كل من:ق{" "}
              {props.issueDate}
              <br />
              <br />
            </p>
            <p>
              <i>
                <b>
                  <u>مجموعة تأشيراتنا أدناه</u>
                </b>
              </i>{" "}
              <br />
              <b>1. رقم التأشيرة : {props.visaNo}</b>
            </p>
          </td>
        </table>
      </Card>
    </div>
  );
});

// export default function EmployeementContractTemplate(
//     {
//         arabicTitle,
//         englishTitle,
//         issueDate,
//         visaNo,
//         idNo,
//         companyName
//     }
// ) {
//   return (
//     <Card title="Employeement Contract" bordered className='container'>
//              <h2 className='t-center m-0'>{arabicTitle}</h2>
//         <h2 className='t-center m-0'>{englishTitle}</h2>
//         <table style={{margin:'20px 10px', width:'100%'}}>
//         <td style={{width:'50%'}}>
//             <h2>Contract ID : {idNo}</h2>

//            <p>
//            This contract was created electronically under the
//                 supervision of the Ministry of Human Resources and
//                 Social Development, Kingdom of Saudi Arabia on
//                 {issueDate}, between:

//             </p>
//             <p><i><b> <u>First Party</u> </b></i> <br />
//             <b>Company/Corporation: {companyName}</b> <br />

//             </p>

//         </td>
//         <td dir='rtl' style={{width:'50%'}}>
//             <h2>رقم العقد:{idNo}</h2>
//             <p>
//             أُبرم هذا العقد الكترونياً تحت إشراف وزارة الموارد البشرية
// والتنمية الاجتماعية، المملكة العربية السعودية في يوم
//  م بين كل من:ق {issueDate}
//             <br />
//             <br />
//             </p>
//             <p><i><b><u>مجموعة تأشيراتنا أدناه</u></b></i> <br />
//             <b>1. رقم التأشيرة : {visaNo}</b>
//             </p>
//         </td>
//         </table>
//     </Card>
//   )
// }

export default EmployeementContractTemplate;
